import { IconButton, TextField, Typography, useTheme } from '@mui/material';
import { Box, Stack } from '@mui/system';
import TagChip from '../TagChip';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import Tooltip from '../Tooltip';

interface IFormInputProps {
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  error?: string;
  value: string;
  placeholder: string;
  label: string;
  required?: boolean;
  name: string;
  smallLabel?: boolean;
  type?: 'password' | 'number' | 'text';
  onAddTag?: (name: string, input: string) => void;
  onDeleteTag?: (idx: number) => void;
  onKeyPress?: (e: React.KeyboardEvent<HTMLDivElement>, field: string, tag: string) => void;
  tags?: string[];
  disabled?: boolean;
  multiline?: boolean;
  maxLength?: number;
  minRows?: number;
  maxRows?: number;
}
const FormInput: React.FC<IFormInputProps> = ({
  onChange,
  onAddTag = () => { },
  onDeleteTag = () => { },
  onKeyPress = () => { },
  error,
  value,
  label,
  required,
  name,
  placeholder,
  smallLabel = false,
  type = 'text',
  tags,
  disabled = false,
  multiline = false,
  maxLength,
  minRows,
  maxRows
}) => {
  const theme = useTheme();

  return (
    <Stack gap={'7px'} sx={{ minHeight: '100px' }}>
      <Stack direction={'row'} alignItems={'baseline'} justifyContent={'space-between'}>
        <Stack direction={'row'} alignItems={'center'} gap={'5px'}>
          <Typography variant={smallLabel ? 'h4' : 'h3'}>
            {label}{' '}
            {required && (
              <Box component={'span'} sx={{ color: 'red' }}>
                *
              </Box>
            )}
          </Typography>
          {tags && <Tooltip message={'Опционально, вводятся через enter'} />}
        </Stack>

        {maxLength && (
          <Typography
            sx={{
              color: value.length === maxLength ? 'red' : theme.custom.palette.primary.basegray,
              fontWeight: value.length === maxLength ? '600' : '400',
            }}
            variant={'small'}
          >
            {value.length}/{maxLength}
          </Typography>
        )}
      </Stack>

      <Stack gap={'12px'}>
        <TextField
          onChange={onChange}
          onKeyPress={(e) => onKeyPress(e, name, value)}
          size={'small'}
          // size={'medium'}
          // variant="outlined"
          error={Boolean(error)}
          helperText={error || ''}
          name={name}
          value={value || ''}
          // margin='normal'
          placeholder={placeholder}
          type={type}
          autoComplete="off"
          inputProps={{
            maxLength
            // maxLength, style: {
            //   height: "190px",
            // },
          }}
          InputProps={{
            endAdornment: tags && (
              <IconButton
                size={'small'}
                onClick={() => onAddTag(name, value)}
                disabled={disabled}
                sx={{ color: theme.custom.palette.primary.default }}
              >
                <KeyboardReturnIcon />
              </IconButton>
            ),
          }}
          multiline={multiline}
          minRows={minRows? minRows : 4}
          maxRows={maxRows? maxRows: 20}
          sx={{
            '& .MuiOutlinedInput-root': {
              '& fieldset': {},
              '&:hover fieldset': {},
              '&.Mui-focused fieldset': {
                borderColor: theme.custom.palette.primary.default,
              },
            }
            // "& .MuiInputBase-root": {
            //   height: 215
            // }
          }}
        />

        {tags && (
          <Stack direction={'row'} gap={'8px'} flexWrap={'wrap'} pb="12px">
            {tags?.map((tag, idx) => (
              <TagChip title={tag} key={idx} onDelete={() => onDeleteTag(idx)} disabled={disabled} />
            ))}
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};

export default FormInput;
